import React from 'react';
import { Container } from '@hover/blueprint';
import { HOW_HOVER_WORKS_LIST_DATA } from '../../../constants';
import { useTabChanger } from '../../../hooks';
import HowItWorksDesktopTabs from './HowItWorksDesktopTabs';
import HowItWorksMobileTabs from './HowItWorksMobileTabs';

const HowHoverWorks: React.FC = () => {
  const { currentTab, resetTimer } = useTabChanger(
    HOW_HOVER_WORKS_LIST_DATA.length,
    9900,
  );

  return (
    <Container maxW="100%" mb={{ base: 1000, desktop: '196px' }}>
      <HowItWorksDesktopTabs currentTab={currentTab} resetTimer={resetTimer} />
      <HowItWorksMobileTabs currentTab={currentTab} resetTimer={resetTimer} />
    </Container>
  );
};

export default HowHoverWorks;
